export const PHONE_DISPLAY = "06 72 08 86 77";
export const PHONE_LINK = "tel:+33672088677";
export const HOURS = "Lundi – Samedi · 9h00 – 18h30";
export const ZONE = "Lot (46) & départements limitrophes";

export const NAV_LINKS = [
  { to: "/", label: "Accueil", testId: "nav-link-accueil" },
  { to: "/interventions", label: "Interventions", testId: "nav-link-interventions" },
  { to: "/contact", label: "Contact", testId: "nav-link-contact" },
];

export const PESTS = [
  {
    id: "rats-souris",
    num: "01",
    name: "Rats & Souris",
    icon: "Rat",
    price: "Sur devis",
    short: "Dératisation complète : inspection, piégeage, appâtage sécurisé et colmatage des accès.",
    detail:
      "Les rongeurs transmettent des maladies (leptospirose, salmonellose) et s'attaquent aux câbles, isolations et denrées. Nous procédons à une inspection complète, posons pièges et appâts sécurisés, puis colmatons les points d'accès pour empêcher toute récidive.",
    image:
      "https://images.unsplash.com/photo-1718345641213-80cfe1424084?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxyYXQlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODc2MzQ3ODB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "guepes-frelons",
    num: "02",
    name: "Guêpes & Frelons",
    icon: "Zap",
    price: "Sur devis",
    short: "Destruction de nids en hauteur ou au sol, y compris frelon asiatique, avec équipement professionnel.",
    detail:
      "Un nid de guêpes ou de frelons près de votre habitation représente un danger réel, surtout pour les personnes allergiques. Nous intervenons avec perche, combinaison et produits professionnels pour neutraliser puis retirer le nid en toute sécurité.",
    image:
      "https://images.pexels.com/photos/20708798/pexels-photo-20708798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "puces",
    num: "03",
    name: "Puces",
    icon: "CircleDot",
    price: "Sur devis",
    short: "Traitement intérieur complet par pulvérisation et brumisation, pièces par pièces.",
    detail:
      "Les puces se reproduisent extrêmement vite et leurs larves se nichent dans les textiles, parquets et plinthes. Nous traitons l'ensemble du logement par pulvérisation et brumisation, avec un protocole précis à suivre pour vos animaux domestiques.",
    image:
      "https://images.pexels.com/photos/12953356/pexels-photo-12953356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "fourmis",
    num: "04",
    name: "Fourmis",
    icon: "Footprints",
    price: "Sur devis",
    short: "Traitement ciblé des colonies, intérieur et extérieur, avec barrières préventives.",
    detail:
      "Les fourmis colonisent cuisines, terrasses et jardins en suivant des pistes bien organisées. Nous ciblons la colonie à la source — reine incluse — avec des gels appâts professionnels et des barrières préventives durables.",
    image:
      "https://images.pexels.com/photos/20826403/pexels-photo-20826403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "blattes-cafards",
    num: "05",
    name: "Blattes & Cafards",
    icon: "Bug",
    price: "Sur devis",
    short: "Éradication par gel appât et pulvérisation, avec suivi jusqu'à élimination totale.",
    detail:
      "Les blattes sont nocturnes, résistantes et vecteurs de bactéries. Nous inspectons les zones infestées (cuisine, salle d'eau, faux plafonds), appliquons gels appâts et insecticides professionnels, puis assurons un suivi jusqu'à l'élimination complète.",
    image:
      "https://images.pexels.com/photos/11362662/pexels-photo-11362662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "moustiques",
    num: "06",
    name: "Moustiques",
    icon: "Crosshair",
    price: "Sur devis",
    short: "Démoustication des jardins et terrasses, traitement des zones de repos et larvaires.",
    detail:
      "Pour retrouver vos extérieurs dès les beaux jours, nous traitons les zones de repos des moustiques (haies, buissons, abords de la maison) et éliminons les gîtes larvaires. Protection durable de vos soirées en terrasse.",
    image:
      "https://images.pexels.com/photos/760086/pexels-photo-760086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "chenilles-processionnaires",
    num: "07",
    name: "Chenilles processionnaires",
    icon: "TreePine",
    price: "Sur devis",
    short: "Suppression des nids en hauteur sur pins et chênes, élimination sécurisée des poils urticants.",
    detail:
      "Les poils urticants des chenilles processionnaires sont dangereux pour les humains et mortels pour les chiens. Nous coupons et détruisons les nids en hauteur, et traitons préventivement vos pins et chênes avant la saison des processions.",
    image:
      "https://images.pexels.com/photos/34300622/pexels-photo-34300622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "punaises-de-lit",
    num: "08",
    name: "Punaises de lit",
    icon: "BedDouble",
    price: "Sur devis",
    short: "Traitement complet des chambres et literies, avec protocole de préparation et suivi.",
    detail:
      "Les punaises de lit se cachent dans les matelas, sommiers, plinthes et prises électriques, et piquent la nuit. Nous inspectons minutieusement les chambres, appliquons un traitement professionnel ciblé et programmons un contrôle pour garantir leur élimination totale.",
    image:
      "https://images.unsplash.com/photo-1693208524433-e04ac504e6c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=85&w=940",
  },
];

export const GUARANTEES = [
  {
    icon: "Timer",
    title: "Intervention rapide",
    text: "Prise en charge immédiate de votre demande et intervention planifiée au plus vite, six jours sur sept.",
  },
  {
    icon: "ShieldCheck",
    title: "Produits certifiés",
    text: "Traitements professionnels homologués, appliqués dans le respect de votre famille et de vos animaux.",
  },
  {
    icon: "FileCheck",
    title: "Devis gratuit",
    text: "Une estimation claire avant toute intervention. Pas de surprise, pas de frais cachés.",
  },
  {
    icon: "MapPinned",
    title: "Ancrage local",
    text: "Basés à Cahors, nous couvrons tout le Lot et les départements limitrophes. Un interlocuteur unique, près de chez vous.",
  },
];

export const REVIEWS = [
  {
    name: "Martine L.",
    place: "Cahors",
    text: "Nid de frelons asiatiques détruit en une seule intervention. Travail propre, rapide et rassurant. Je recommande vivement.",
  },
  {
    name: "Bernard D.",
    place: "Pradines",
    text: "Problème de rats dans la grange réglé en deux semaines, avec de vrais conseils pour éviter leur retour. Très professionnel.",
  },
  {
    name: "Sophie V.",
    place: "Figeac",
    text: "Réseau de fourmis traité à la source. Ponctuel, efficace et de bon conseil. Enfin débarrassés.",
  },
];

export const IMAGES = {
  heroTechnician:
    "https://images.pexels.com/photos/19789837/pexels-photo-19789837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cahors:
    "https://images.pexels.com/photos/10713993/pexels-photo-10713993.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
